import { SlingoEvent } from "@lib/titan2-slingo/dist/game/controller/event/SlingoEvent";
import { Reels } from "@lib/titan2-slingo/dist/game/view/abstract/display/Reels";
import { GameEvent } from "../../../controller/event/GameEvent";
import { GameSoundEvent } from "../../../controller/event/GameSoundEvent";
/**
 * GameReels.ts
 */
export class GameReels extends Reels {
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(GameEvent.FEATURE_START, this.hide);
        this.registerGame(GameEvent.FEATURE_END, this.show);
        this.registerGame(SlingoEvent.DAB_SUCCESS, this.handleDabSuccess);
        this.registerGame(SlingoEvent.DAB_ACTIVE, this.handleDabActive);
        this.registerGame(GameEvent.RECOVER_REEL_SYMBOLS, this.handleSymbolsRecovery);
        this.registerGame(GameEvent.SCATTER_WIN_SUSPENSE_STOP, this.stopScatterSuspense);
    }
    handlePurchaseEntry() {
        super.handlePurchaseEntry();
    }
    handleRecovery() {
        super.handleRecovery();
        this.handleDabActive();
        this.handleReelsAward();
    }
    handleSymbolsRecovery() {
        const reelSequence = this.model.getSpinResult().getReelSequence();
        const symbols = reelSequence.getSymbols();
        const undabbedJokers = reelSequence.getJokerIndexes();
        const undabbedSuperJokers = reelSequence.getSuperJokerIndexes();
        symbols.forEach((symbol, index) => {
            if (symbol.isJoker() && !undabbedJokers.includes(index)) {
                this.reels[index].collectJoker();
            }
            else if (symbol.isSuperJoker() && !undabbedSuperJokers.includes(index)) {
                this.reels[index].collectSuperJoker();
            }
        });
    }
    handleFreeSpinAward() {
        const next = this.freeSpinIndices.shift();
        if (typeof next === "number" && this.reels[next]) {
            this.reels[next].collectFreeSpin();
        }
    }
    handleDabSuccess() {
        const symbol = this.model.getLatestMatchedSymbol();
        const column = this.model.getLatestMatchedSymbolColumn();
        const reel = this.reels[column];
        if (symbol.isJoker()) {
            reel.collectJoker();
        }
        else if (symbol.isSuperJoker()) {
            reel.collectSuperJoker();
        }
        else {
            reel.collectNumber();
        }
    }
    handleDabActive() {
        const symbols = this.model.getReelDisplayData().getDisplaySymbols();
        for (const [column, reel] of this.reels.entries()) {
            if (this.model.columnSymbolMatched(column)) {
                continue;
            }
            const symbol = symbols[column];
            if (symbol.isJoker()) {
                reel.activateJoker();
            }
            else if (symbol.isSuperJoker()) {
                reel.activateSuperJoker();
            }
        }
    }
    checkSuspense() {
        const stopIndex = this.model.getReelDisplayData().getStopIndex();
        const scatterCount = this.model.getScatterCount();
        const scatterThreshold = this.model.getScatterThreshold();
        if (scatterThreshold > -1 && scatterCount >= scatterThreshold) {
            for (let i = 0; i < stopIndex; ++i) {
                this.reels[i].suspenseScatter();
            }
            for (let i = stopIndex; i < this.reels.length; i++) {
                this.reels[i].suspense();
            }
            this.dispatchGame(GameEvent.SCATTER_WIN_SUSPENSE);
        }
        const winLine = this.model.getWinLine();
        if (winLine) {
            if (stopIndex < this.reels.length && this.model.hasWinLineSuspense(stopIndex, winLine)) {
                this.dispatchGame(GameSoundEvent.SUSPENSE_WIN_LINE);
                // Start suspense on all reels from the stop index onwards.
                for (let i = stopIndex; i < this.reels.length; i++) {
                    this.reels[i].suspense();
                }
                this.dispatchGame(GameEvent.WIN_LINE_SUSPENSE);
            }
            else if (this.model.hasWinLineSuspense(stopIndex - 1, winLine)) {
                this.dispatchGame(GameEvent.WIN_LINE_COMPLETE);
            }
        }
    }
    async stopScatterSuspense() {
        await Promise.all(this.reels.map(reel => reel.awaitScatterSuspenseDelay()));
        await Promise.all(this.reels.map(reel => reel.stopScatterSuspense()));
    }
}
//# sourceMappingURL=GameReels.js.map